module.exports = __webpack_public_path__ + "img/cadwell-turnbull.53f51e39.png";